



































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import jsEncrypt from '@/shared/jsEncrypt';

const cssPrefix = 'usedomain-modal';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
  },
})
export default class UsedomaincredModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  userName : any = '';
  pwd : any = '';
  modalTitle = '';
  isSubmitted : boolean = false;
  @Prop({ required : true })
  email : any;
  created() {
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.isSubmitted = true;
    if (this.pwd.trim().length > 0 && this.userName.trim().length > 0) {
      const request = {
        emailAddress : this.email,
        domainUserName : this.userName,
        domainPwd : jsEncrypt
          .getEncryptObj_msw()
          .encrypt(this.pwd),
        captchaText : '',
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/enableDomainCred', request)
      .then((resp) => {
        if (resp.operationStatus === 'OK') {
         // this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.$emit('success', resp.msgDesc);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
        this.$store.commit('stopLoading');
      });
    }
  }
  cancel() {
    this.$emit('failed', true);
    this.$emit('close-modal');
  }
}
